export default __webpack_public_path__ + "static/international-yards-mobile-381a786b2a4513d4eda7da96fb602cee.svg";